import { CurrencyPipe } from "@angular/common";
import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    TemplateRef,
    Input,
    AfterViewInit,
    OnChanges,
    SimpleChanges,
    Output,
    EventEmitter,
    OnDestroy
} from "@angular/core";

import { FinanziamentoService, AreeTematicheService, MotivazioneCancellazioneService, StorageService } from "../../services";
import { AuthService } from "src/app/services";

import { NgxDatatableWrapperComponent } from "src/app/components/_components/ngxDatatableWrapper/ngx-datatable-wrapper.component";
import { ColumnMode } from "@swimlane/ngx-datatable";

import { ToastService } from "src/app/services/toast.service";

import { defineLocale } from "ngx-bootstrap/chronos";
import { itLocale } from "ngx-bootstrap/locale";
import localeIt from "@angular/common/locales/it";
import { OrderPipe } from "ngx-order-pipe";
import { registerLocaleData } from "@angular/common";
import { DirtyComponent } from "../../../../models/dirty-component";
import { FinanziamentoComponent } from "../finanziamento/finanziamento.component";
import { IsDirtyHelper } from "../../../../helpers/is-dirty.helper";
import { ActivatedRoute } from "@angular/router";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

registerLocaleData(localeIt, "it");
defineLocale("it", itLocale);

@Component({
    selector: "finanziamenti-component",
    templateUrl: "./finanziamenti.component.html",
    styleUrls: ["./finanziamenti.component.css"],
})
export class FinanziamentiComponent
    implements OnInit, DirtyComponent, AfterViewInit, OnChanges, OnDestroy {
    dtOptions: any = {};
    @ViewChild("btnEditTemplate", { static: true })
    public btnEditTemplate: TemplateRef<any>;

    @ViewChild("btnDeleteTemplate", { static: true })
    public btnDeleteTemplate: TemplateRef<any>;

    @ViewChild("annualitaFieldValueTemplate", { static: true })
    public annualitaFieldValueTemplate: TemplateRef<any>;

    @ViewChild("disponibilitaFieldValueTemplate", { static: true })
    public disponibilitaFieldValueTemplate: TemplateRef<any>;

    @ViewChild("btnCheckTemplate", { static: true })
    public btnCheckTemplate: TemplateRef<any>;

    @ViewChild("fieldNoteTemplate", { static: true })
    public fieldNoteTemplate: TemplateRef<any>;

    @ViewChild("fonteStrumentoAttuativoValueTemplate", { static: true })
    public fonteStrumentoAttuativoValueTemplate: TemplateRef<any>;

    @ViewChild("direzioneFieldValueTemplate", { static: true })
    public direzioneFieldValueTemplate: TemplateRef<any>;

    @ViewChild("ngxDatatableWrapper")
    ngxDatatableWrapper: NgxDatatableWrapperComponent;

    @ViewChild("finanziamentoComponent")
    finanziamentoComponent: FinanziamentoComponent;

    @ViewChild("extraFilterTemplate", { static: true })
    public extraFilterTemplate: TemplateRef<any>;

    @Input()
    filters: any = null;

    @Output()
    disableButtonEmit = new EventEmitter<boolean>();
    @Output()
    disableSearchEmitter = new EventEmitter<boolean>();

    templateList = [];
    mode: string = "list";
    loading: boolean = false;

    itemsComboFilterPnrr = [{ id: 'Si', descrizione: 'Si' }, { id: 'No', descrizione: 'No' }];

    columns = [
        {
            name: "id",
            prop: "id",
            visible: false,
            sortable: true,
            filtrable: true,
            width: 10,
        },
        {
            name: "codice",
            prop: "codice",
            sortable: true,
            filtrable: true,
            flexGrow: 3,
            minWidth: 100,
        },
        {
            name: "titolo",
            prop: "titolo",
            sortable: true,
            filtrable: true,
            flexGrow: 5,
            minWidth: 100,
        },
        {
            name: "fonte<br />strumento<br />attuativo",
            prop: "tipoFinanziamento.tipoFinanziamento",
            sortable: true,
            filtrable: true,
            cellTemplate: "fonteStrumentoAttuativoValueTemplate",
            flexGrow: 5,
            minWidth: 100,
        },
        {
            name: "aree gestionali",
            prop: "descrizioneAreeTematiche" /*'areeTematiche'*/,
            sortable: true,
            filtrable: true,
            resizeable: false,
            draggable: false,
            cellTemplate: "direzioneFieldValueTemplate",
            flexGrow: 5,
            minWidth: 140,
        },
        {
            name: "importo",
            prop: "importoComplessivo",
            sortable: false,
            filtrable: false,
            cellTemplate: "annualitaFieldValueTemplate",
            flexGrow: 6,
            minWidth: 160,
        },
        {
            name: "disponibilità<br/>residua",
            prop: "disponibilitaResidua",
            sortable: false,
            filtrable: false,
            cellTemplate: "disponibilitaFieldValueTemplate",
            flexGrow: 6,
            minWidth: 160,
        },
        {
            name: "scadenza",
            prop: "scadenza",
            sortable: true,
            filtrable: true,
            cellTemplate: "dateValueTemplate",
            flexGrow: 3,
            minWidth: 85,
        },
        {
            name: "stato",
            prop: "validazione.validationStatus",
            sortable: true,
            filtrable: true,
            cellTemplate: "btnCheckTemplate",
            flexGrow: 3,
            minWidth: 60,
        },
        {
            name: "note",
            prop: "note",
            sortable: true,
            filtrable: false,
            cellTemplate: "fieldNoteTemplate",
            flexGrow: 2,
            minWidth: 45,
        },
        {
            name: "modifica",
            prop: "id",
            sortable: false,
            filtrable: false,
            cellTemplate: "btnEditTemplate", // 'buttonsTemplate'
            flexGrow: 2,
            minWidth: 60,
        },
        {
            name: "elimina",
            prop: "id",
            sortable: false,
            filtrable: false,
            cellTemplate: "btnDeleteTemplate", // 'buttonsTemplate'
            flexGrow: 2,
            minWidth: 60,
        },
        {
            name: "",
            prop: "tipoStrumentoAttuativo.descrizione",
            sortable: true,
            filtrable: true,
            flexGrow: 1,
            minWidth: 0,
            visible: false,
        }
        , {
            name: 'rilevante PNRR'
            , prop: 'pnrrRilevante'
            , visible: false
            , sortable: false
            , filtrable: true
            , resizeable: false
            , draggable: false
            , flexGrow: 2
            , minWidth: 75
            , cellTemplate: 'booleanValueTemplate'
        }
    ];

    section: string = 'Finanziamenti';

    constructor(
        private el: ElementRef,
        private toastr: ToastService,
        private currentService: FinanziamentoService,
        private orderPipe: OrderPipe,
        private authService: AuthService,
        private isDirtyHelper: IsDirtyHelper,
        private areeTematicheService: AreeTematicheService,
        private route: ActivatedRoute
        , private modalService: BsModalService
        , private formBuilder: FormBuilder
        , private motivazioneCancellazioneService: MotivazioneCancellazioneService
        , private storageService: StorageService
    ) {
        this.deleteForm = this.initializeDeleteFormGroup();
        this.getMotivazioniCancellazione();
        this.getAreeTematiche();
        this.dtOptions = {
            rows: [],
            totalElements: 0,
            columns: this.columns,
            columnMode: ColumnMode.flex,
            headerHeight: "50",
            footerHeight: "50",
            rowHeight: "auto",
            externalSorting: true, // true
            loadingIndicator: "loanding",
            class: "bootstrap",
            summaryRow: true,
            summaryPosition: "'bottom'",
            externalPaging: true, // true
            count: 0,
            offset: 0,
            limit: 10,
            serverSide: true,
            scrollbarH: "true",
            ajax: this.getFinanziamenti,
            sorts: [{ dir: "asc", prop: "codice" }],
            extraFilterTemplate: (this.isAdmin() || this.isGr34()) ? this.extraFilterTemplate : null,
            /*,order : [{ dir: 'desc', column: 1 }]*/
        };
        //this.getFinanziamenti();
        //this.getTipiFinanziamento();
        //this.getTipiStrumentiAttuativi();
    }
    ngOnDestroy(): void {
        if (this.elencoAreeSubscription) this.elencoAreeSubscription.unsubscribe();
    }

    canDeactivate() {
        let isDirty = this.isDirtyHelper.isDirty;
        console.log(`isDirty= ${isDirty}`);
        return isDirty;
    }

    ngOnInit() {
        window.scroll(0, 0);

        this.templateList = [
            {
                name: "direzioneFieldValueTemplate",
                template: this.direzioneFieldValueTemplate,
            },
            {
                name: "fonteStrumentoAttuativoValueTemplate",
                template: this.fonteStrumentoAttuativoValueTemplate,
            },
            { name: "btnCheckTemplate", template: this.btnCheckTemplate },
            {
                name: "disponibilitaFieldValueTemplate",
                template: this.disponibilitaFieldValueTemplate,
            },
            {
                name: "annualitaFieldValueTemplate",
                template: this.annualitaFieldValueTemplate,
            },
            { name: "btnDeleteTemplate", template: this.btnDeleteTemplate },
            { name: "btnEditTemplate", template: this.btnEditTemplate },
            { name: "fieldNoteTemplate", template: this.fieldNoteTemplate },
        ];
        this.dtOptions.extraFilterTemplate = (this.isAdmin() || this.isGr34()) ? this.extraFilterTemplate : null;
        this.ngxDatatableWrapper ? this.ngxDatatableWrapper.dtOptions = this.dtOptions : null;
    }

    ngAfterViewInit() {
        this.route.params.subscribe((params) => {
            const finanziamentoId = params["id"];

            finanziamentoId && this.onEdit({ id: finanziamentoId });
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        switch (true) {
            case changes.filters !== undefined:
                setTimeout(() => {
                    this.ngxDatatableWrapper.refresh();
                }, 0);
                break;
        }
    }

    getFinanziamenti = (dataTablesParameters: any, callback: any) => {
        this.currentService.getAllDt(dataTablesParameters, this.filters).subscribe((resp) => {
            callback(resp);
            this.disableSearchEmitter.emit(false);
        });
    };

    onEdit(row) {
        this.disableButtonEmit.emit(true);
        this.mode = "insertedit";
        //this.finanziamento = row;
        this.finanziamentoId = row.id;
    }

    onInsert() {
        this.mode = "insertedit";
        this.finanziamento = null;
        if (!this.finanziamentoId) this.finanziamentoId = -1;
        else this.finanziamentoId = null;
    }

    onDelete(row) {
        if (this.loading || this.isReadOnly(row)) return;
        console.log(row);
        this.openConfirmDeleteModal(row);
        return;

        if (
            !confirm(
                `Stai per eliminare il finanziamento "${row.titolo}", proseguire?`
            )
        )
            return;
        this.loading = true;
        this.currentService.delete(row.id).subscribe(
            (result) => {
                this.loading = false;
                this.ngxDatatableWrapper.deleteRow(row);
                this.toastr.success("Finanziamento eliminato con successo", null, {
                    timeOut: 2000,
          /*closeButton:true,*/ disableTimeOut: false,
                });
            },
            (error) => {
                this.loading = false;
                this.toastr.error(
                    `Impossibile eliminare il finanziamento: ${error.error.message
                        ? error.error.message
                        : error.error.error_description
                            ? error.error.error_description
                            : error.error
                    }`,
                    null,
                    {
                        timeOut: 2000,
            /*closeButton:true,*/ disableTimeOut: false,
                    }
                );
                console.log("error");
            }
        );
    }

    printValueAsCurrency(value) {
        if (!value) value = 0;
        //return this.italianCurrencyPipe.parse(value) + " €";
        value = typeof value === "number" ? value : value.replace(",", ".").trim();
        const format = "1.2-2";
        const currency = "€";
        const currentLocale: string = "it";
        return new CurrencyPipe(currentLocale).transform(
            value,
            "EUR",
            currency,
            format,
            "it-IT"
        );
    }
    sortImporti(arr) {
        return this.orderPipe.transform(arr, "anno");
    }

    isAdmin() {
        return this.authService.isAdmin();
    }
    isDirectionalGroup() {
        return this.authService.isDirectionalGroup();
    }
    isAreaStaff() {
        return this.authService.isAreaStaff();
    }
    isExternal() {
        return this.authService.isExternal();
    }

    isViewer() {
        return this.authService.isViewer();
    }
    isGruppoPnrr() {
        return this.authService.isGruppoPnrr();
    }
    isGr34() {
        return this.authService.isGr34();
    }





    printBtnValidazioneTitle(value) {
        let result = '';
        switch (value) {
            case '':
            case 'IDLE':
            case 'REJECT':
                if (this.isAdmin())
                    result = 'clicca per validare';
                else
                    result = 'clicca per richiedere la validazione';
                break;
            case 'APPROVED':
            case 'TERMINATO':
                if (this.isAdmin()) result = 'clicca per svalidare';
                break;
            case "WAITING_FOR_APPROVAL_FIRST_LEVEL":
                if (!(this.isAreaStaff() || this.isExternal())) result = 'clicca per validare';
                break;
            case "WAITING_FOR_APPROVAL_SECOND_LEVEL":
                if (this.isAdmin())
                    result = 'clicca per validare';
                break;

        }
        return result;
    }

    onRichiediValidazione(row: any) {
        if (this.isReadOnly(row)) return;
        let status = row.validazione
            ? row.validazione.validationStatus
                ? row.validazione.validationStatus
                : 0
            : 0;
        let msg = "";
        let action = false;
        //status =0 posso richiede approvazione
        switch (status.toString().toUpperCase()) {
            case "0":
            case "IDLE":
            case "REJECTED":
            case "3":
                if (this.isAdmin())
                    msg = `Stai per validare il finanziamento ${row.titolo}, proseguire?`;
                else
                    msg = `Stai per richiedere la validazione del finanziamento ${row.titolo}, proseguire?`;
                action = true;
                break;
            case "1":
            case "APPROVED":
                if (this.isAdmin())
                    msg = `Stai per annullare la validazione del finanziamento ${row.titolo}, proseguire?`;
                else return; //msg = `Stai per richiedere l'annullamento della validazione del finanziamento ${row.titolo}, proseguire?`;
                action = false;
                break;
            case "4":
            case "WAITING_FOR_APPROVAL_FIRST_LEVEL":
                if (this.isAreaStaff() || this.isExternal()) return;
                msg = `Stai per validare il finanziamento ${row.titolo}, proseguire?`;
                action = true;
                break;
            case 5:
            case "WAITING_FOR_APPROVAL_SECOND_LEVEL":
                if (!this.isAdmin()) return;
                msg = `Stai per validare il finanziamento ${row.titolo}, proseguire?`;
                action = true;
                break;
            /*case 6:
                      if (!this.isAdmin())return;
                      msg = `Stai per annullare la validazione del finanziamento ${row.titolo}, proseguire?`;
                      action=false;
                      break;*/
            default:
                return;
        }
        if (!confirm(msg)) return;
        this.currentService.manageValidation(row.id, action).subscribe(
            (result) => {
                this.reloadAll();
                let msg = "";
                if ((this.isAreaStaff() || this.isExternal()) && action)
                    msg = "Richiesta di validazione avvenuta con successo";
                if ((this.isAdmin() || this.isDirectionalGroup()) && action)
                    msg = "Validazione avvenuta con successo";
                if (this.isAdmin() && !action)
                    msg = "Validazione annullata con successo";
                this.toastr.success(msg, null, {
                    timeOut: 2000,
                    disableTimeOut: false,
                });
                if (result.warningMessage && result.warningMessage != "") {
                    this.toastr.warning(result.warningMessage, null, {
                        timeOut: 10000,
                        disableTimeOut: false,
                    });
                }
            },
            (error) => {
                this.toastr.error(
                    `Errore: ${error.error.message
                        ? error.error.message
                        : error.error.error_description
                            ? error.error.error_description
                            : error.error
                    }`,
                    null,
                    {
                        timeOut: 2000,
                        disableTimeOut: false,
                    }
                );
                console.log("error");
            }
        );
    }

    reloadAll() {
        //this.getFinanziamenti();
        this.ngxDatatableWrapper.refresh();
    }

    isReadOnly(info: any): boolean {
        //controllo se l'utente può modificare il progetto
        //let user = this.authService.getCurrentUser();
        return info.isReadOnly || !this.canEdit();
    }

    printDirezioneFieldValue(data) {
        let str = "";
        let arr = [];
        if (data && data != "") {
            //let obj = JSON.parse(data);

            for (let o in data) {
                let str = data[o]["descrizione"];
                if (data[o]["disabled"]) str = `(disattiva) ${str}`;
                arr.push(str);
            }
            str = arr.join("<br />");
        }
        return arr;
    }

    finanziamento = null;
    _finanziamentoId: number;

    @Input()
    set finanziamentoId(value: number) {
        this._finanziamentoId = value;
    }
    get finanziamentoId(): number {
        return this._finanziamentoId;
    }

    gotoBackList($event) {
        this.disableButtonEmit.emit(false);
        this.finanziamento = null;
        this.finanziamentoId = null;
        this.reloadAll();
        this.mode = "list";
    }

    areeTematicheCombo = [];
    private elencoAreeSubscription = null;
    getAreeTematiche() {
        this.elencoAreeSubscription = this.storageService.elencoAreeTematiche.subscribe(
            x => {
                console.log(x);
                this.areeTematicheCombo = x ? x : [];
            }
        );
    }

    filterAreaTematica($event) {
        let descr = $event ? $event.descrizione : "";
        if (descr.startsWith('(disattiva)')) {
            descr = descr.replace('(disattiva)', '');
        }
        this.ngxDatatableWrapper.originalColumns[4].search = {
            value: descr,
            regex: false,
        };
        this.ngxDatatableWrapper.dtInputParams.columns[4].search = {
            value: descr,
            regex: false,
        };
        this.ngxDatatableWrapper.refresh();
        //this.filterArea = $event ? $event.id : -1;
        //this.filterInterventions(false);
    }


    //modale conferma cancellazione
    @ViewChild('modalConfirmDelete', { static: true })
    public modalConfirmDelete: TemplateRef<any>;

    modalRef: BsModalRef;

    deleteRowTitle = '';
    deleteForm: FormGroup;
    submitted = false;
    deletedRow = null;

    initializeDeleteFormGroup(): FormGroup {
        let frm = this.formBuilder.group({
            motivazione: [null, [Validators.required]],
            txtMotivazioneCancellazione: [null],
        });
        return frm;
    }

    openConfirmDeleteModal(row) {
        this.submitted = false;
        this.deletedRow = row;
        this.deleteRowTitle = row.titolo;
        this.deleteForm.reset();
        let config = {
            animated: true,
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
            class: "modal-lg"
        };
        this.modalRef = this.modalService.show(this.modalConfirmDelete, config);
    }

    closeConfirmDeleteModal() {
        this.modalRef.hide();
    }

    doDelete() {
        this.submitted = true;
        this.deleteForm.updateValueAndValidity();
        for (let c in this.deleteForm.controls) {
            this.deleteForm.controls[c].updateValueAndValidity();
        }
        let errors = false;
        for (let c in this.deleteForm.controls) {
            errors = errors || this.deleteForm.controls[c].errors !== null;
            console.log(
                "this.f[" + c + "].errors:" + JSON.stringify(this.deleteForm.controls[c].errors)
            );
        }



        if (errors || this.deleteForm.invalid) {
            console.log("invalid");
            let invalidElements = []; // this.el.nativeElement.querySelectorAll('.is-invalid');
            for (let el in this.deleteForm.controls) {
                if (this.deleteForm.controls[el].invalid) {
                    console.log(`set focus on ${el}`);
                    if (this.deleteForm.controls[el] instanceof FormGroup) {
                        for (let el1 in this.deleteForm.get(el)["controls"]) {
                            if (this.deleteForm.get(el)["controls"][el1].invalid) {
                                invalidElements = this.el.nativeElement.querySelectorAll(
                                    `[formcontrolname="${el1}"]`
                                );
                                break;
                            }
                        }
                    } else {
                        invalidElements = this.el.nativeElement.querySelectorAll(
                            `[formcontrolname="${el}"]`
                        );
                    }
                    break;
                }
            }
            if (invalidElements.length > 0) {
                invalidElements[0].focus();
            }

            return false;
        }
        //no errors
        let obj = this.deleteForm.value;
        if (obj.motivazione == 'Altro') obj.motivazione = obj.txtMotivazioneCancellazione;
        this.closeConfirmDeleteModal();
        //return;
        this.loading = true;
        this.currentService.delete(this.deletedRow.id, obj.motivazione).subscribe(
            (result) => {
                this.loading = false;
                this.ngxDatatableWrapper.deleteRow(this.deletedRow);
                this.toastr.success("Finanziamento eliminato con successo", null, {
                    timeOut: 2000,
          /*closeButton:true,*/ disableTimeOut: false,
                });
            },
            (error) => {
                this.loading = false;
                this.toastr.error(
                    `Impossibile eliminare il finanziamento: ${error.error.message
                        ? error.error.message
                        : error.error.error_description
                            ? error.error.error_description
                            : error.error
                    }`,
                    null,
                    {
                        timeOut: 2000,
                        disableTimeOut: false,
                    }
                );
                console.log("error");
            }
        );


    }

    motivazioniCancellazione = [];
    getMotivazioniCancellazione() {
        this.motivazioneCancellazioneService.getAll().subscribe(
            result => {
                result.push({ descrizione: 'Altro' });
                this.motivazioniCancellazione = result;
            }
        );
    }
    motivazioneCancellazioneSelected = null;
    setMotivazioneCancellazione($event) {
        this.motivazioneCancellazioneSelected = $event ? $event.descrizione : null;
        if (this.motivazioneCancellazioneSelected && this.motivazioneCancellazioneSelected == 'Altro') {
            this.deleteForm.controls.txtMotivazioneCancellazione.setValidators(Validators.required);
        }
        else {
            this.deleteForm.controls.txtMotivazioneCancellazione.clearValidators();
        }
    }

    /**
  * Controlla se l'utente può accedere o meno alla sezione.
  * @param section il nome della sezione
  * @param operations le operazioni da poter effettuare sulla sezione
  * @param atLeastOne opzionale. Se true almeno un'operazione deve essere contenuta nei permessi, tutte altrimenti. Ha valore false di default
  * @param enableOnNotFound opzionale. Se true (default) e non esiste la sezione settata nei permessi, ritorna true, false altrimenti
  * @returns true se il controllo è andato a buon fine, false altrimenti
 */
    enableSection(section: string, operations: string[], atLeastOne: boolean = false, enableOnNotFound: boolean = true): boolean {
        return this.authService.checkPermissionBySectionAndOperations(section, operations, atLeastOne, enableOnNotFound);
    }

    canInsert() {
        return (this.enableSection(this.section, ['insert'], null, this.isAdmin() || this.isGruppoPnrr()));
    }
    canEdit() {
        return (this.enableSection(this.section, ['update'], null, this.isAdmin() || this.isGruppoPnrr()));
    }
    canDelete() {
        return (this.enableSection(this.section, ['delete'], null, this.isAdmin()));
    }

    filterRilevantePnrr($event) {
        let descr = $event ? $event.descrizione : "";
        let id = $event ? $event.id : null;
        let value = id ? (id.toLowerCase() == 'si' ? true : false) : null;
        let col = this.ngxDatatableWrapper.originalColumns.find(x => x.prop == 'pnrrRilevante');

        if (col)
            col.search = {
                value: value,
                regex: false,
            };

        this.ngxDatatableWrapper.refresh();
    }
}
